import React from "react";

// Convert simple **bold** markdown spans into <strong>, preserve everything else.
// Each segment gets a stable key derived from its position + a short hash of
// content so React can safely diff during streaming updates.
function hashKey(str, pos) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return `${pos}-${h}`;
}

export default function RichText({ text }) {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return (
    <>
      {parts.map((p, i) => {
        if (p.startsWith("**") && p.endsWith("**")) {
          return (
            <strong
              key={hashKey(p, i)}
              className="font-semibold text-[#242f44]"
            >
              {p.slice(2, -2)}
            </strong>
          );
        }
        return <React.Fragment key={hashKey(p, i)}>{p}</React.Fragment>;
      })}
    </>
  );
}
